import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import CustomToast from "../../components/CustomToast";
import ListInformation from "../../components/ListInformation";
import { approveUser, clearFormService } from "../../services/adminService";
import { getUserPaymentInformationService } from "../../services/userService";
import CustomImageWithLabel from "../../components/CustomImageWithLabel";
import Loader from "../../utils/Loader";
import { getLocalStorageItem } from "../../utils/LocalStorage";
import { Button, Popover } from "@mui/material";
import { ErrorHandler } from "../../utils/ErrorHandler";

function UserDetailForG4() {
  const { state } = useLocation();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const token = getLocalStorageItem();
  const dateFormat = "dddd DD/MM/YYYY";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getUser = async () => {
    setLoading(true);
    try {
      const { data } = await getUserPaymentInformationService(
        state?.id,
        state?.role,
        token
      );
      if (data) {
        setUser(data[0]);
      }
    } catch (error) {
      ErrorHandler(error).map((e) => CustomToast("error", e?.message));
    }
    setLoading(false);
  };

  useEffect(() => {
    getUser();
    return () => {};
  }, []);

  const handleApprove = async () => {
    setLoading(true);
    try {
      const { data } = await approveUser(
        { id: state.userId, role: state.role },
        token
      );
      if (data) {
        CustomToast("success", "User Approved");
        navigate("/approveUser");
      }
    } catch (error) {
      console.log("err", error);
      ErrorHandler(error).map((e) => CustomToast("error", e?.message));
    }
    setLoading(false);
  };

  const handleClearForm = async () => {
    setLoading(true);
    try {
      const { data } = await clearFormService(
        { userId: user.user_id, paymentID: user.paymentID },
        token
      );
      if (data.data) {
        CustomToast("success", data.data);
        navigate("/approveUser", { replace: true });
        handleClose();
      }
    } catch (error) {
      handleClose();
      ErrorHandler(error).map((e) => CustomToast("error", e?.message));
    }
    setLoading(false);
  };

  const userInfo = user?.user ?? {};

  return (
    <div>
      <div className="flex flex-col ">
        {loading ? (
          <Loader />
        ) : user?.user?.firstName ? (
          <div className="relative p-8">
            <div className="">
              {userInfo?.profilePicture && (
                <CustomImageWithLabel
                  label="Profile picture"
                  picture={userInfo?.profilePicture}
                  containerWidth={"w-full md:w-[100%] px-20"}
                  height={200}
                  width={150}
                />
              )}
            </div>
            <div className="flex flex-col md:flex-row flex-wrap md:justify-between">
              {userInfo?.firstName && (
                <ListInformation label="Name" value={userInfo?.firstName} />
              )}
              {userInfo?.lastName && (
                <ListInformation
                  label="Father Name"
                  value={userInfo?.lastName}
                />
              )}
              {userInfo?.motherFullName && (
                <ListInformation
                  label="Mother Full Name"
                  value={userInfo?.motherFullName}
                />
              )}
              {userInfo?.email && (
                <ListInformation label="Email" value={userInfo?.email} />
              )}
              {user?.paymentReferenceNo && (
                <ListInformation
                  label="Payment Reference Number"
                  value={user?.paymentReferenceNo}
                />
              )}
              {user?.paymentAmount && (
                <ListInformation
                  label="Payment Amount"
                  value={user?.paymentAmount}
                />
              )}
              {user?.bank && (
                <ListInformation label="Bank" value={user?.bank} />
              )}
              {user?.paymentDate && (
                <ListInformation
                  label="Payment Date"
                  value={moment(user?.paymentDate).format(dateFormat)}
                />
              )}
              {userInfo?.birthDate && (
                <ListInformation
                  label="Date of Birth"
                  value={moment(userInfo?.birthDate).format(dateFormat)}
                />
              )}

              {userInfo?.tinNumber && (
                <ListInformation
                  label="Tin Number"
                  value={userInfo?.tinNumber}
                />
              )}

              {userInfo?.idPicture && (
                <CustomImageWithLabel
                  label="Passport/ Id picture"
                  picture={userInfo?.idPicture}
                  containerWidth={"w-full md:w-[100%] px-20"}
                  width={200}
                  height={150}
                />
              )}
            </div>
            <div className="flex my-2 justify-between w-[100%] md:w-[50%] max-w-[300px]">
              <button
                onClick={handleApprove}
                className="bg-green-500 w-max min-w-[80px] rounded-md cursor-pointer text-[14px] md:text-[16px] text-white p-0.5 md:p-1"
              >
                Approve
              </button>
              <button
                onClick={handleClick}
                className="bg-red-500 w-max min-w-[80px] rounded-md cursor-pointer text-[14px] md:text-[16px] text-white p-0.5 md:p-1"
              >
                Clear
              </button>
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl && anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <div className="px-5 p-2.5">
                  <p>Are you sure you want to clear the user info?</p>
                  <div className="flex justify-evenly my-2">
                    <Button
                      color="success"
                      size="small"
                      variant="contained"
                      onClick={handleClearForm}
                    >
                      Yes
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      color="error"
                      onClick={handleClose}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center">
            <h4 className="mt-10 text-[#c46969] text-xl">
              Error occurred, Please try again{" "}
            </h4>
            <p
              onClick={() => getUser()}
              className="bg-slate-600 w-[30%] mt-2 rounded-md text-white p-2 cursor-pointer"
            >
              Retry
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserDetailForG4;
